const deptMixins = {
  data() {
    return {
      enterpriseId: '',
      deptTreeData: [],
      loadingTreeData: false
    }
  },
  watch: {
    'enterpriseId': function(newVal) {
      this.getTreeData(this.enterpriseId)
    }
  },
  mounted() {
    this.getTreeData(this.enterpriseId)
  },
  methods: {
    getTreeData(enterpriseId) {
      if (this.loadingTreeData) {
        return
      }
      this.loadingTreeData = true
      const url = `member/v3/auth/getDeptTree/${enterpriseId}`
      this.getHttpServices().getMemberAuthService().post(url)
        .then(data => {
          this.deptTreeData = data ? data : []
          this.loadingTreeData = false
        })
        .catch(err => {
          this.loadingTreeData = false
          this.$message.error('操作失败，请重试！')
          console.log(err)
        })
    }
  }
}
export default deptMixins